import {put, takeEvery} from 'redux-saga/effects';

import {getOrderReviewItems} from 'desktop/pages/checkout/store/reducers/orderReviewItems/orderReviewItems';

import {
    updateCartItem,
    updateCartItemSubscription,
} from '../../reducers/changeItemQty/changeItemQty';
import {getQuote} from '../../reducers/quoteItems/quoteItems';

/**
 * onUpdateCartItem only on Cart Page
 */
export function* onUpdateCartItem() {
    yield put(getQuote({}));
}

/**
 * onUpdateCartItemSubscription when subscription is updated
 */
function* onUpdateCartItemSubscription() {
    yield put(getOrderReviewItems({collectTax: false, withTaxErrors: false}));
}

/**
 * Begin of saga
 */
export default function* updateCartSaga() {
    yield takeEvery(
        [`${updateCartItem.fulfilled}`, `${updateCartItemSubscription.fulfilled}`],
        onUpdateCartItem,
    );
    yield takeEvery(`${updateCartItemSubscription.fulfilled}`, onUpdateCartItemSubscription);
}
